import { PRODUCT_INFO_TAB_SET_ACTIVE_TAB } from '../Actions/ProductInfoTab.action';

const DEFAULT_STATE = {
    activeInfoTab: '',
    explodedViewCount: 0,
};

export const productInfoTab = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case PRODUCT_INFO_TAB_SET_ACTIVE_TAB:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}